import React from 'react';
import loadFileIcon from '../../assets/icons/load file.png';

export default function SidebarUploadButton({ onClick }) {
  return (
    <button type="button" className="nd-uploadBtn sidebar-upload-btn" onClick={onClick}>
      <img src={loadFileIcon} alt="" style={{ width: 20, height: 20, objectFit: 'contain' }} />
      Загрузка документа
    </button>
  );
}
